import React, { useState } from 'react';
import { interviewsAPI } from '../lib/api';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { toast } from 'sonner';

export default function InterviewDataRequestPage() {
  const [accessCode, setAccessCode] = useState('');
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!accessCode.trim() || !email.trim()) {
      toast.error('Please enter your interview access code and email');
      return;
    }
    setSubmitting(true);
    try {
      const res = await interviewsAPI.requestDataDeletion({ access_code: accessCode.trim(), email: email.trim() });
      setDone(res.data);
      toast.success('Your interview data has been deleted.');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'No matching interview records were found.');
    } finally {
      setSubmitting(false);
    }
  };

  const inputStyle = { width:'100%', padding:'0.75rem', borderRadius:10, border:'1px solid #CBD5E1', background:'#FAF7F2', color:'#002A38', fontSize:'0.875rem', outline:'none', boxSizing:'border-box' };

  return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'100vh', background:'#F1EAE1', padding:'2rem' }} data-testid="interview-data-request-page">
      <Card style={{ background:'#fff', border:'1px solid #ECE7DE', borderRadius:14, padding:'2.5rem', maxWidth:520, width:'100%' }}>
        <h1 style={{ fontFamily:'Cabinet Grotesk', fontSize:'1.5rem', fontWeight:700, marginBottom:'0.5rem', color:'#0076A3' }}>Delete My Interview Data</h1>
        <p style={{ fontSize:'0.875rem', color:'#64748B', lineHeight:1.7, marginBottom:'1.75rem' }}>
          Under the Illinois Artificial Intelligence Video Interview Act (820 ILCS 42), you may request deletion of your AI video interview data.
          Enter the access code from your interview invitation and the email you used. Your data and any copies will be deleted within 30 days.
        </p>

        {done ? (
          <div data-testid="interview-data-request-success" style={{ padding:'1.25rem', borderRadius:12, background:'rgba(16,185,129,0.08)', border:'1px solid rgba(16,185,129,0.25)' }}>
            <p style={{ fontSize:'0.9375rem', fontWeight:700, color:'#059669', marginBottom:'0.375rem' }}>Deletion complete</p>
            <p style={{ fontSize:'0.8125rem', color:'#4A5568', lineHeight:1.6 }}>
              We deleted {done.sessions_deleted} interview record{done.sessions_deleted === 1 ? '' : 's'} associated with your email. No further action is needed.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:'1rem' }}>
            <div>
              <label style={{ display:'block', fontSize:'0.75rem', fontWeight:600, color:'#64748B', marginBottom:'0.375rem' }}>Interview Access Code</label>
              <input data-testid="data-request-access-code" value={accessCode} onChange={(e) => setAccessCode(e.target.value)} placeholder="e.g. ABC123" style={inputStyle} />
            </div>
            <div>
              <label style={{ display:'block', fontSize:'0.75rem', fontWeight:600, color:'#64748B', marginBottom:'0.375rem' }}>Email Used for the Interview</label>
              <input data-testid="data-request-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" style={inputStyle} />
            </div>
            <Button type="submit" data-testid="data-request-submit" disabled={submitting} style={{ background:'#0076A3', color:'#fff', borderRadius:10, padding:'0.875rem', fontWeight:600, fontSize:'0.9375rem' }}>
              {submitting ? 'Processing...' : 'Delete My Interview Data'}
            </Button>
          </form>
        )}

        <p style={{ fontSize:'0.6875rem', color:'#94A3B8', marginTop:'1.5rem', lineHeight:1.6 }}>
          Questions about your data? See our <a href="/legal/privacy" style={{ color:'#0076A3' }}>Privacy Policy</a> or contact the hiring organisation.
        </p>
      </Card>
    </div>
  );
}
